import styles from '../Tabelas.module.css'
import Container from '../../../../components/components-ui/Container/Container'
import Button from '../../../../components/components-ui/Button/Button'
import { Grid, Col } from '../../../../components/Grid'
import api from '../../../../services/Api'
import * as Yup from 'yup'
import { Formik, Form, Field } from 'formik'
import 'react-toastify/dist/ReactToastify.css'
import { toast } from 'react-toastify'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'

export default function Action() {
  const { id } = useParams()
  const [nomePreferenciaContato, setNomePreferenciaContato] = useState('')

  function showAlert(notify, msg) {
    if (notify === 0) {
      toast.success(msg, {autoClose: 2500})
    } else {
      toast.error(msg)
    }
  }

  async function createPreferenciaContato(values) {
    const response = await api.post('/preferenciacontato/create/', {
      preferencia_contato: values.preferenciaContato,
    })
    if (response.data.error === 0) {
      showAlert(0, response.data.msg)
      navigate('/usina/preferencia-contato')
      return
    }
    showAlert(1, response.data.msg)
  }

  async function editarPreferenciaContato(values) {
    const response = await api.put(`/preferenciacontato/edit/${id}`, {
      preferencia_contato: values.preferenciaContato,
    })
    if (response.data.error === 0) {
      showAlert(0, response.data.msg)
      navigate('/usina/preferencia-contato')
      return
    }
    showAlert(1, response.data.msg)
  }

  useEffect(() => {
    if (id) {
      async function getNomePreferencia() {
        const response = await api.get(`/preferenciacontato/show/${id}`)
        setNomePreferenciaContato(response.data.PreferenciaContato)
      }
      getNomePreferencia()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const navigate = useNavigate()
  const validadtionSchema = Yup.object().shape({
    preferenciaContato: Yup.string().required('*Campo Obrigatório'),
  })
  return (
    <Container>
      <h3>
        {id
          ? 'Edição de Preferencia de Contato'
          : 'Cadastro de Preferencia de Contato'}
      </h3>
      <section className={styles.action_section}>
        <Formik
          enableReinitialize={true}
          initialValues={{ preferenciaContato: nomePreferenciaContato }}
          onSubmit={
            id
              ? (values) => editarPreferenciaContato(values)
              : (values) => createPreferenciaContato(values)
          }
          validationSchema={validadtionSchema}
        >
          {({ errors, touched }) => (
            <Form>
              <Grid>
                <Col size={12}>
                  <label> Preferencia Contato </label>
                  <Field type="text" name="preferenciaContato" />
                  {errors.preferenciaContato && touched.preferenciaContato ? (
                    <span className={styles.alertError}>
                      {errors.preferenciaContato}
                    </span>
                  ) : null}
                </Col>
              </Grid>
              <Grid>
                <Col size={12}>
                  <Button type="submit" title={'Salvar'} />
                  <Button
                    type="button"
                    title="Voltar"
                    color="secondary"
                    onClick={() => {
                      navigate('/usina/preferencia-contato')
                    }}
                  />
                </Col>
              </Grid>
            </Form>
          )}
        </Formik>
      </section>
    </Container>
  )
}
